import { render, staticRenderFns } from "./ConfigurationListView.vue?vue&type=template&id=3af3031a&scoped=true&"
import script from "./ConfigurationListView.vue?vue&type=script&lang=js&"
export * from "./ConfigurationListView.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationListView.vue?vue&type=style&index=0&id=3af3031a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af3031a",
  null
  
)

export default component.exports